import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

// [4.9.2] Field-log of materials consumed on an obra, imputing cost to the work.
export interface WorkMaterialConsumption {
  id: number;
  workId: number;
  workName: string;
  description: string;
  quantity: number;
  unit: string | null;
  unitCost: number | null;
  totalCost: number;
  consumedOn: string;
  notes: string | null;
  created: string;
  lastModified: string;
}

export interface WorkMaterialConsumptionPayload {
  workId: number;
  description: string;
  quantity: number;
  unit?: string | null;
  unitCost?: number | null;
  consumedOn: string;
  notes?: string | null;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

export function getWorkMaterialConsumptions(
  workId: number,
): Promise<WorkMaterialConsumption[]> {
  return request<WorkMaterialConsumption[]>(
    `/api/work-material-consumptions?workId=${workId}`,
  );
}

export function createWorkMaterialConsumption(
  payload: WorkMaterialConsumptionPayload,
): Promise<WorkMaterialConsumption> {
  return request<WorkMaterialConsumption>("/api/work-material-consumptions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateWorkMaterialConsumption(
  id: number,
  payload: WorkMaterialConsumptionPayload,
): Promise<WorkMaterialConsumption> {
  return request<WorkMaterialConsumption>(
    `/api/work-material-consumptions/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    },
  );
}

export async function deleteWorkMaterialConsumption(id: number): Promise<void> {
  const response = await fetch(
    `${apiBaseUrl}/api/work-material-consumptions/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    },
  );

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }
}
